import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReplaceDeeplinksPipe } from './replace-deeplinks.pipe';

@NgModule({
  declarations: [ReplaceDeeplinksPipe],
  imports: [CommonModule],
  exports: [ReplaceDeeplinksPipe]
})
export class ReplaceDeeplinksModule {}
